var $name="video/utils",$path="app/modules/video/utils.js",$this={$name,$path,};import forEach from 'lodash/forEach';
import keys from 'lodash/keys';

const YOUKU_DOMAIN_EXP = /youku\.com/g;
const YOUKU_SRC_LINK = 'https://player.youku.com/embed/';
const YOUKU_VIDEO_ID_EXP = /^id_/;
const BOKE_CC_DOMAIN_EXP = /bokecc\.com/g;
const BOKE_CC_SRC_LINK = 'https://p.bokecc.com/';
const BOKE_CC_URL_TYPE_QR = 'qrplay.bo';
const BOKE_CC_URL_TYPE_HTML = 'playhtml.bo';
const BOKE_CC_URL_USER_ID = 'uid=';
const BOKE_CC_URL_SITE_ID = 'siteid=';
const YOUTUBE_DOMAIN_EXP = /youtube\.com/g;

const defaultPlayerVariables = {
  autoplay: 1,
  controls: 2,
  enablejsapi: 1,
  listType: 'playlist',
  cc_lang_pref: '%lang%',
  cc_load_policy: 1,
};

function checkIfYouKuLink(videoUrl) {
  return videoUrl.match(YOUKU_DOMAIN_EXP);
}

function checkIfBokeCCLink(videoUrl) {
  return videoUrl.match(BOKE_CC_DOMAIN_EXP);
}

function checkIfYoutubeLink(videoUrl) {
  return videoUrl.match(YOUTUBE_DOMAIN_EXP);
}

function getYouKuSrcLink(source) {
  function configSrcLink(videoId) {
    return `${YOUKU_SRC_LINK}${videoId}`;
  }

  if (checkIfYouKuLink(source)) {
    return configSrcLink(source.split('/').pop().replace(YOUKU_VIDEO_ID_EXP, ''));
  }

  return source;
}

function getBokeCCSrcLink(source) {
  function configSrcLink(videoId) {
    return `${BOKE_CC_SRC_LINK}${videoId}`;
  }

  if (checkIfBokeCCLink(source)) {
    return configSrcLink(
      source.split('/').pop()
        .replace(BOKE_CC_URL_TYPE_QR, BOKE_CC_URL_TYPE_HTML)
        .replace(BOKE_CC_URL_USER_ID, BOKE_CC_URL_SITE_ID),
    );
  }

  return source;
}

function initYouKu(node, videoSource) {
  const youKuPlayer = document.createElement('iframe');
  youKuPlayer.setAttribute('src', videoSource);
  youKuPlayer.setAttribute('allowfullscreen', true);
  youKuPlayer.setAttribute('title', 'youku-iframe');
  youKuPlayer.className = node.className;

  node.parentNode.replaceChild(youKuPlayer, node);
}

function initBokeCC(node, videoSource) {
  const bokeCCPlayer = document.createElement('iframe');
  bokeCCPlayer.setAttribute('src', videoSource);
  bokeCCPlayer.setAttribute('allowFullscreen', 'true');
  bokeCCPlayer.setAttribute('title', 'bokecc-iframe');
  bokeCCPlayer.className = node.className;

  node.parentNode.replaceChild(bokeCCPlayer, node);
}

/**
 * Verifies if player node targets YouKu
 * @param {Object} playerNode - DOM node which contains data attribute "videolink"
 */
function isYouKuLink(playerNode) {
  if (playerNode && playerNode.dataset.videolink) {
    const videoSrc = playerNode.dataset.videolink;
    return checkIfYouKuLink(videoSrc);
  }
  return false;
}
/**
 * Creates YouKu player
 * @param {Object} playerNode - DOM node which contains data attribute "videolink"
 */
function initYouKuPlayer(playerNode) {
  if (playerNode && playerNode.dataset.videolink) {
    initYouKu(playerNode, getYouKuSrcLink(playerNode.dataset.videolink));
  }
}

/**
 * Verifies if player node targets bokeCC
 * @param {Object} playerNode - DOM node which contains data attribute "videolink"
 */
function isBokeCCLink(playerNode) {
  if (playerNode && playerNode.dataset.videolink) {
    const videoSrc = playerNode.dataset.videolink;
    return checkIfBokeCCLink(videoSrc);
  }
  return false;
}
/**
 * Creates BokeCC player
 * @param {Object} playerNode - DOM node which contains data attribute "videolink"
 */
function initBokeCCPlayer(playerNode) {
  if (playerNode && playerNode.dataset.videolink) {
    initBokeCC(playerNode, getBokeCCSrcLink(playerNode.dataset.videolink));
  }
}

function getCombinedPlayerVariables(node, variables) {
  const isSubtitleEnabled = node?.hasAttribute('data-subtitles-enabled');
  const subtitlesLang = isSubtitleEnabled ? node.dataset.subtitlesLang : null;
  const playerVariables = variables || {};
  const defaultPlayer = {
    autoplay: defaultPlayerVariables.autoplay,
    controls: defaultPlayerVariables.controls,
    enablejsapi: defaultPlayerVariables.enablejsapi,
    origin: window.location.origin,
  };

  if (node && node.dataset.videolink) {
    const videoSrc = new URL(node.dataset.videolink);
    const urlParams = new URLSearchParams(videoSrc.search);
    const videoListQuery = urlParams.get('list');

    if (videoListQuery) {
      defaultPlayer.list = videoListQuery;
      defaultPlayer.listType = defaultPlayerVariables.listType;
    }
  }

  forEach(
    keys(defaultPlayer),
    (key) => {
      if (!(key in playerVariables)) {
        playerVariables[key] = defaultPlayer[key];
      }
    },
  );

  if (isSubtitleEnabled) {
    defaultPlayerVariables.cc_lang_pref = subtitlesLang;
    playerVariables.cc_lang_pref = subtitlesLang;
    playerVariables.cc_load_policy = 1;
  }

  return playerVariables;
}

export {
  checkIfYoutubeLink,
  checkIfYouKuLink,
  defaultPlayerVariables,
  getBokeCCSrcLink,
  getCombinedPlayerVariables,
  getYouKuSrcLink,
  initBokeCCPlayer,
  initYouKuPlayer,
  isBokeCCLink,
  isYouKuLink,
};
